import { useState } from "react";
import { 
  Button, 
  Modal, 
  Input, 
  Checkbox, 
  Alert, 
  Card, 
  Row,
  Col,
  Typography,
  Switch,
  message,
  Spin
} from "antd";

const { Text } = Typography;

const VerificationData = ({ API_URL }) => {
  const [showPopup, setShowPopup] = useState(true);
  const [password, setPassword] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [verificationResult, setVerificationResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState(null);

  const handleVerify = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await fetch(`${API_URL}/verifyAdmin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          password,
          isVerified 
        }),
      });

      if (!response.ok) {
        throw new Error('Verification failed');
      }

      const result = await response.json();
      setVerificationResult(result);
      const accoutnDeleteRequestLength = (result?.data || []).filter(user=>user.accountDeletionRequest).length
      if(accoutnDeleteRequestLength){
        alert(`${accoutnDeleteRequestLength} accountDeletionRequest request found`)
      }
      setShowPopup(false);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateVerification = async (userId, newStatus) => {
    setUpdating(true);
    try {
      const response = await fetch(`${API_URL}/updateVerification`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          isVerified: newStatus,
          password,
          userId
        }),
      });

      if (!response.ok) {
        throw new Error('Update failed');
      }

      const result = await response.json();
      
      setVerificationResult(prev => ({
        ...prev,
        data: prev.data.map(user => 
          user.userId === userId ? { ...user, isVerified: newStatus } : user
        )
      }));
      
      message.success('Verification status updated successfully');
    } catch (err) {
      message.error(err.message);
      setVerificationResult(prev => ({
        ...prev,
        data: prev.data.map(user => 
          user.userId === userId ? { ...user, isVerified: !newStatus } : user
        )
      }));
    } finally {
      setUpdating(false);
    }
  };

  return (
    <>
      <Modal
        title="Enter Verification Password"
        visible={showPopup}
        onCancel={() => setShowPopup(false)}
        footer={[
          <Button key="cancel" onClick={() => setShowPopup(false)}>
            Cancel
          </Button>,
          <Button 
            key="verify" 
            type="primary" 
            onClick={handleVerify} 
            loading={loading}
          >
            Verify
          </Button>,
        ]}
      >
        <Input.Password
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter password"
          style={{ marginBottom: 16 }}
        />
        
        <Checkbox
          checked={isVerified}
          onChange={(e) => setIsVerified(e.target.checked)}
        >
          Show verified accounts
        </Checkbox>
        
        {error && (
          <Alert 
            message={error} 
            type="error" 
            showIcon 
            style={{ marginTop: 16 }}
          />
        )}
      </Modal>

      {loading && <Spin size="large" style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }} />}

      {verificationResult ? (
        <div style={{ 
          marginTop: 20,
          height: 'calc(100vh - 20px)', // Adjust this value as needed
          overflowY: 'auto',
          padding: '0 16px'
        }}>
          <Text strong style={{ display: 'block', marginBottom: 16 }}>
            Result for isVerified: {verificationResult.verified === "yes" ? 'Yes' : 'No'}
          </Text>
          <Row gutter={[16, 16]}>
            {verificationResult.data.map((user, index) => (
              <Col key={index} xs={24} sm={12} md={8} lg={6}>
                <Card 
                  title={user.businessName} 
                  style={{ marginBottom: 16 }}
                  extra={
                    <Switch
                      checked={user.isVerified}
                      onChange={(checked) => handleUpdateVerification(user.userId, checked)}
                      loading={updating}
                    />
                  }
                >
                  <p>Mobile: {user.mobileNumber}</p>
                  <p>Verified: {user.isVerified ? 'Yes' : 'No'}</p>
                  {user.accountDeletionRequest && (
                    <p style={{color: "red"}}>Account Deletion Request: {user.accountDeletionRequest}</p>
                  )}
                  {user.address && <p>Address: {user.address}</p>}
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      ): `no data to show for isVerified: ${isVerified}`}
    </>
  );
};

export default VerificationData;